import { Injectable } from '@angular/core';
import { IMapper } from '@core/base/mapper.interface';
import { IProfileForm } from '../interfaces/profile-form.interface';
import { IUserSession } from 'src/app/modules/auth/interfaces/user-session.interace';

@Injectable()
export class ProfileApiToFormMapperService implements IMapper<IUserSession, IProfileForm> {
  mapTo(apiData: IUserSession): IProfileForm {
    return {
      name: apiData.name,
      email: apiData.email,
    };
  }
}
